import { createFileRoute } from "@tanstack/react-router";
import { AttendanceDropScreen } from "../components/relations/AttendanceDropScreen";

export const Route = createFileRoute("/_auth/relations/attendance")({
  staticData: {
    titleKey: "relations.attendance.title",
    breadcrumbKey: "breadcrumb.operate",
    breadcrumbN: 7,
  },
  component: AttendanceDropScreen,
});
